import React from "react";

const SomethingWrong = () => {
  return <div>SomethingWrong</div>;
};

export default SomethingWrong;
